// no itx for this file
import Channel from "../models/Channel";
import { ChannelType } from "../models/ChannelType";
import SignalTypes from "../models/SignalTypes";
import { matchN } from "./determineActorComObjectFunction";

import Logger from "../Logger";
import { getSignalTypeBundle } from "../models/SignalBundles";
import { itx } from "../translationItx/itx";
import { TAG_ENVIRONMENT } from "../models/Constants";
import SignalType from "src/models/SignalType";

const logger = new Logger("determineChannelTpyes");

export function determineChannelTypes(channels: Array<Channel>, isActor: boolean) {
  function isStaircaseLightChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.StaircaseLight); // staircase light
    });
    return res;
  }

  function isSwitchChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Switch);
    });
    return res;
  }

  function isLockChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Lock);
    });
    return res;
  }

  function isStatusDisplayChannel(channel: Channel): ChannelType | undefined {
    const xSignals = channel.signals.findAsArray((signal) => !signal.isDummySignal  && signal.type.name != SignalTypes.Ignored.name &&  signal.type.name != SignalTypes.Unknown.name );
    if (xSignals.length == 1 && xSignals[0].type.isStatus) {
      switch (xSignals[0].type.name) {
        case SignalTypes.StatusDisplaySwitch.name:
        case SignalTypes.SwitchStatus.name:
          return ChannelType.StatusDisplaySwitch;

        case SignalTypes.DimValue.name:
          return ChannelType.StatusDisplayDimValue;

        case SignalTypes.Temperature_TargetStatus.name:
        case SignalTypes.Temperature_TargetComfortStatus.name:
        case SignalTypes.Temperature_Current.name:
          return ChannelType.StatusDisplayTemperature;
      }
    }

    return undefined;
  }

  function isDimChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.DimStep);
      res ||= signal.type.equals(SignalTypes.DimValue);
    });
    return res;
  }

  function isTuneableWhiteChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.ColorTemperatureStep);
      res ||= signal.type.equals(SignalTypes.ColorTemperatureKelvin);
      res ||= signal.type.equals(SignalTypes.TWWarmWhiteValue);
      res ||= signal.type.equals(SignalTypes.TWColdWhiteValue);
      res ||= signal.type.equals(SignalTypes.TWWarmWhiteStep);
      res ||= signal.type.equals(SignalTypes.TWColdWhiteStep);
      res ||= signal.type.equals(SignalTypes.ColorTemperaturePercent);
      res ||= signal.type.equals(SignalTypes.TunableWhiteBrightnessTransition249_600);
    });
    return res;
  }

  function isChannelOfType(checkOfChannelType: ChannelType, channel: Channel): boolean {
    const bundle = getSignalTypeBundle(checkOfChannelType);
    for (let signal of channel.signals.asArray()) {
      const b = bundle.findIndex((signalType) => signalType.equals(signal.type));
      if (b >= 0) {
        return true;
      }
    }

    return false;
  }

  function isTemperaturSetpointChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Temperature_TargetShift_9);
      res ||= signal.type.equals(SignalTypes.Temperature_TargetShift_6);
      res ||= signal.type.equals(SignalTypes.Temperature_TargetStep_1);
      res ||= signal.type.equals(SignalTypes.Temperature_Target);
      res ||= signal.type.equals(SignalTypes.Temperature_TargetStatus);
      res ||= signal.type.equals(SignalTypes.Temperature_CurrentDisplay);
    });

    return res;
  }

  function isHeatingControl(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Temperature_ControlValue);
      res ||= signal.type.equals(SignalTypes.Temperature_ValveState);
      res ||= signal.type.equals(SignalTypes.Temperature_ControlValueStatus);
      res ||= signal.type.equals(SignalTypes.Temperature_ValveStateStatus);
    });

    return res;
  }

  function isOperationMode(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.OperationMode);
    });

    return res;
  }

  function isJalousieChannel(channel: Channel): boolean {
    if (!isBlindChannel(channel)) {
      return false;
    }

    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.SlatPosition);
      res ||= signal.type.equals(SignalTypes.SlatPositionStatus);
    });
    return res;
  }

  function isBlindChannel(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.BlindPosition);
      res ||= signal.type.equals(SignalTypes.BlindMove);
      res ||= signal.type.equals(SignalTypes.BlindStopStep);
      res ||= signal.type.equals(SignalTypes.BlindSingleObjectControl);
    });
    return res;
  }

  function isTemperatureMeasurement(channel: Channel): boolean {
    var res = false;
    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Temperature_Current);
    });
    return res;
  }

  function isSceneChannel(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res = signal.type.equals(SignalTypes.Scene);
    });

    return res;
  }

  function isRGBChannel(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.RGBValue);
      res ||= signal.type.equals(SignalTypes.RGBValueStatus);
      res ||= signal.type.equals(SignalTypes.RGBValue6Byte);
      res ||= signal.type.equals(SignalTypes.RGBValueStatus6Byte);
      res ||= signal.type.equals(SignalTypes.RGBRedSwitch);
      res ||= signal.type.equals(SignalTypes.RGBRedSwitchStatus);
      res ||= signal.type.equals(SignalTypes.RGBRedValue);
      res ||= signal.type.equals(SignalTypes.RGBRedStep);
      res ||= signal.type.equals(SignalTypes.RGBRedValueStatus);
      res ||= signal.type.equals(SignalTypes.RGBGreenSwitch);
      res ||= signal.type.equals(SignalTypes.RGBGreenSwitchStatus);
      res ||= signal.type.equals(SignalTypes.RGBGreenValue);
      res ||= signal.type.equals(SignalTypes.RGBGreenStep);
      res ||= signal.type.equals(SignalTypes.RGBGreenValueStatus);
      res ||= signal.type.equals(SignalTypes.RGBBlueSwitch);
      res ||= signal.type.equals(SignalTypes.RGBBlueSwitchStatus);
      res ||= signal.type.equals(SignalTypes.RGBBlueValue);
      res ||= signal.type.equals(SignalTypes.RGBBlueStep);
      res ||= signal.type.equals(SignalTypes.RGBBlueValueStatus);
      res ||= signal.type.equals(SignalTypes.HSVValue);
      res ||= signal.type.equals(SignalTypes.HSV_HueStep);
      res ||= signal.type.equals(SignalTypes.HSV_HueValue);
      res ||= signal.type.equals(SignalTypes.HSV_HueValueStatus);
      res ||= signal.type.equals(SignalTypes.HSV_SaturationStep);
      res ||= signal.type.equals(SignalTypes.HSV_SaturationValue);
      res ||= signal.type.equals(SignalTypes.HSV_SaturationValueStatus);
      res ||= signal.type.equals(SignalTypes.HSV_ColorValue);
      res ||= signal.type.equals(SignalTypes.HSV_ColorValueStatus);
    });

    return res;
  }
  function isRGBWChannel(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.RGBWhiteStep);
      res ||= signal.type.equals(SignalTypes.RGBWhiteValue);
      res ||= signal.type.equals(SignalTypes.RGBWhiteValueStatus);
      res ||= signal.type.equals(SignalTypes.RGBWhiteSwitch);
      res ||= signal.type.equals(SignalTypes.RGBWhiteSwitchStatus);
    });

    return res;
  }

  function isEnvironmentChannel(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.equals(SignalTypes.Date);
      res ||= signal.type.equals(SignalTypes.DateTime);
      res ||= signal.type.equals(SignalTypes.Time);
      res ||= signal.type.equals(SignalTypes.DayNight);
    });

    return res;
  }

  function isGeneralChannel(channel: Channel): boolean {
    if ((channel as any).isGeneralChannel || channel.name.toLocaleLowerCase().startsWith("general")) return true;

    var res = false;

    channel.signals.forEach((signal) => {
      const resBegin = res;
      res ||= matchN(["central", "global"], signal.name);
      res ||= matchN(["central", "global"], signal.knxFunctionText);
      if (res) {
        if (matchN(["block central"], signal.name) || matchN(["block central"], signal.knxFunctionText)) {
          res = resBegin;
        }
      }
    });

    return res;
  }

  function isGenericValueChannel(channel: Channel): boolean {
    var res = false;

    channel.signals.forEach((signal) => {
      res ||= signal.type.name == SignalTypes.GenericValue.name;
    });

    return res;
  }

  let ct: ChannelType | undefined;

  // detect the channel Type
  channels.forEach((channel) => {
    if (channel.signals.size > 0) {
      if (channel.channelType == ChannelType.Unknown) {
        if (isGeneralChannel(channel)) {
          channel.channelType = ChannelType.General;
          channel.name = "General";
        } else if (isJalousieChannel(channel)) {
          channel.channelType = ChannelType.Jalousie;
        } else if (isBlindChannel(channel)) {
          channel.channelType = ChannelType.Blind;
          channel.signals.forEach((signal) => {
            const text = signal.knxFunctionTextEN.toLowerCase() + signal.knxTextEN.toLowerCase();
            if (text.includes("slat") || text.includes("lamelle")) {
              // berker only in german so that lamelle should be used
              channel.channelType = ChannelType.Jalousie;
            }
          });
        } else if (
          (isTemperatureMeasurement(channel) && isTemperaturSetpointChannel(channel)) ||
          (isActor && isHeatingControl(channel))
        ) {
          channel.channelType = ChannelType.Heating;
        } else if (isTemperaturSetpointChannel(channel)) {
          if (isActor) {
            channel.channelType = ChannelType.Heating;
          } else {
            channel.channelType = ChannelType.TemperatureSetpoint;
          }
        } else if (isTemperatureMeasurement(channel)) {
          if (isActor) {
            channel.channelType = ChannelType.Heating;
          } else {
            channel.channelType = ChannelType.TemperatureMeasurement;
          }
          // } else if (isRGBWChannel(channel)) {
          //   channel.channelType = ChannelType.Rgbw;
        } else if (isRGBChannel(channel)) {
          channel.channelType = ChannelType.Rgb;
        } else if (isTuneableWhiteChannel(channel)) {
          channel.channelType = ChannelType.TuneableWhite;
        } else if (isDimChannel(channel)) {
          channel.channelType = ChannelType.Dimmer;
        } else if (isStaircaseLightChannel(channel)) {
          channel.channelType = ChannelType.StaircaseLight;
        } else if (isSwitchChannel(channel)) {
          channel.channelType = ChannelType.Switch;
        } else if ((ct = isStatusDisplayChannel(channel))) {
          channel.channelType = ct;
        } else if (!isActor && isSceneChannel(channel)) {
          channel.channelType = ChannelType.Scene;
        } else if (isEnvironmentChannel(channel)) {
          channel.channelType = ChannelType.Environment;
          channel.name = itx("channelType.Environment");
          channel.tag = TAG_ENVIRONMENT;
        } else if (isGenericValueChannel(channel)) {
          channel.channelType = ChannelType.GenericValue;
        } else if (isLockChannel(channel)) {
          channel.channelType = ChannelType.Lock;
        } else if (isOperationMode(channel)) {
          channel.channelType = ChannelType.OperationMode;
        } else {
          channel.channelType = ChannelType.Unknown;
        }

        logger.log(`determineChannelTypes  ${channel.name} ${channel.channelType}`, channel);
      }
    }
  });
}
